//export const serverCrm = 'dev';
export const serverCrm = 'clients';

